import clsx from "clsx"
import type { IProps, TVoxStatusTone } from "./interfaces"
import classes from "./styles.module.css"

const TONE_CLASSES: Record<TVoxStatusTone, string> = {
  neutral: classes.neutral,
  active: classes.active,
  tension: classes.tension,
  reward: classes.reward,
  revealed: classes.revealed,
  archived: classes.archived,
}

/**
 * Pill-shaped in-world status indicator from the Voxcanon design
 * vocabulary — leading dot (or pulse on sci-fi), Cinzel uppercase label,
 * wax-seal outline on parchment, luminous halo on cosmic. Use for
 * "Magic Active", "High Tension", "Reward Earned", "Revealed",
 * "Archived" — anything that lives in-world rather than in the pipeline
 * lifecycle (status of meeting processing belongs in StatusPill).
 */
export const VoxStatusPill = ({ tone = "neutral", leading, children, pulse }: IProps): React.JSX.Element => {
  return (
    <span className={clsx(classes.pill, TONE_CLASSES[tone], pulse && classes.pulse)}>
      {leading ? (
        <span className={classes.leading}>{leading}</span>
      ) : (
        <span className={classes.dot} aria-hidden="true" />
      )}
      <span>{children}</span>
    </span>
  )
}
